/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RenameListRequest
 */
export interface RenameListRequest {
  /**
   *
   * @type {string}
   * @memberof RenameListRequest
   */
  companyListId: string;
  /**
   *
   * @type {string}
   * @memberof RenameListRequest
   */
  name: string;
}

/**
 * Check if a given object implements the RenameListRequest interface.
 */
export function instanceOfRenameListRequest(
  value: object,
): value is RenameListRequest {
  if (!("companyListId" in value) || value["companyListId"] === undefined)
    return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function RenameListRequestFromJSON(json: any): RenameListRequest {
  return RenameListRequestFromJSONTyped(json, false);
}

export function RenameListRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RenameListRequest {
  if (json == null) {
    return json;
  }
  return {
    companyListId: json["companyListId"],
    name: json["name"],
  };
}

export function RenameListRequestToJSON(json: any): RenameListRequest {
  return RenameListRequestToJSONTyped(json, false);
}

export function RenameListRequestToJSONTyped(
  value?: RenameListRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyListId: value["companyListId"],
    name: value["name"],
  };
}
